import React from "react";
import {cva} from "class-variance-authority";
import {Loader2} from "lucide-react";
import {cn} from "../../utils/cn";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 font-medium rounded-md " +
    "transition-colors duration-fast whitespace-nowrap " +
    "focus-visible:outline-none focus-visible:ring focus-visible:ring-offset-2 " +
    "disabled:opacity-50 disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        primary:
          "bg-accent-500 text-white shadow-xs hover:bg-accent-600 active:bg-accent-700",
        secondary:
          "bg-white text-ink-700 border border-ink-200 hover:bg-ink-50 hover:border-ink-300 active:bg-ink-100",
        tertiary:
          "bg-transparent text-ink-700 hover:bg-ink-100 active:bg-ink-200",
        danger:
          "bg-danger-600 text-white shadow-xs hover:bg-danger-700 active:bg-danger-800",
        link: "text-brand-700 hover:underline underline-offset-2 px-0",
        ghost:
          "bg-transparent text-ink-500 hover:text-ink-700 hover:bg-ink-100",
      },
      size: {
        sm: "h-8 px-3 text-sm",
        md: "h-9 px-4 text-base",
        lg: "h-11 px-5 text-base",
        icon: "h-9 w-9 p-0",
      },
    },
    defaultVariants: {variant: "secondary", size: "md"},
  }
);

const Button = React.forwardRef(function Button(
  {
    className,
    variant,
    size,
    icon: Icon,
    iconRight: IconRight,
    loading = false,
    children,
    ...props
  },
  ref
) {
  return (
    <button
      ref={ref}
      className={cn(buttonVariants({variant, size}), className)}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
      ) : Icon ? (
        <Icon className={cn(size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4")} aria-hidden="true" />
      ) : null}
      {children}
      {IconRight && !loading ? (
        <IconRight className={cn(size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4")} aria-hidden="true" />
      ) : null}
    </button>
  );
});

export default Button;
export {buttonVariants};
